import { render, staticRenderFns } from "./AppDetailView.vue?vue&type=template&id=477b6d1e&scoped=true"
import script from "./AppDetailView.vue?vue&type=script&lang=js"
export * from "./AppDetailView.vue?vue&type=script&lang=js"
import style0 from "./AppDetailView.vue?vue&type=style&index=0&id=477b6d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b6d1e",
  null
  
)

export default component.exports